import React, { useState } from 'react';
import { CustomisedTooltip, styleConstants } from '@hwm/ui-lib';
import { InfoOutlined } from '@material-ui/icons';
import { ClickAwayListener, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: styleConstants.colors.darkBlue,
    width: 280,
    border: '1px solid #dadde9',
    zIndex: 9999,
  },
}));

interface CustomTooltipProps {
  tooltipText: React.ReactNode;
}

export const CustomTooltip: React.FC<CustomTooltipProps> = ({ tooltipText }) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  return tooltipText ? (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <CustomisedTooltip
        title={tooltipText}
        placement="bottom-end"
        disableFocusListener
        disableHoverListener
        disableTouchListener
        open={open}
        onClose={() => setOpen(false)}
        classes={{
          tooltip: classes.tooltip,
        }}
      >
        <InfoOutlined color="primary" style={{ fontSize: 20 }} onClick={() => setOpen(true)} />
      </CustomisedTooltip>
    </ClickAwayListener>
  ) : null;
};
